import { useEffect, memo } from 'react';
import { useInstanceStatus } from "../hooks/useInstanceStatus";
import { useHostStatus } from "../hooks/useHostStatus";
import Status from "../types/Status";

// Constants.
function StatusIconDisplay(props: { instanceId?: number, removeFromList?: Function, hostId?: number, status: Status }) {
    const { instanceId, removeFromList, hostId, status } = props;

    useEffect(() => {
        if (instanceId && instanceId > 0 && status.status === 404 && removeFromList) {
            removeFromList(instanceId);
        }
    }, [instanceId, removeFromList, status.status]);

    useEffect(() => {
        if (hostId && hostId > 0 && status.status === 404 && removeFromList) {
            removeFromList(hostId);
        }
    }, [hostId, removeFromList, status.status]);

    let className = 'fas fa-question-circle text-secondary fa-fw';
    let tooltip = 'Health unknown';
    const reason = status.reason ? ` - ${status.reason}` : '';

    if (status.state.toLowerCase() === 'started') {
        if (status.status === 200) {
            className = 'fas fa-shield-check text-success fa-fw';
            tooltip = `Sensor - ${status.state}${reason}`;
        } else {
            className = 'fas fa-question-circle text-danger fa-fw';
            tooltip = `Sensor - ${status.message}`;
        }
    } else {
        tooltip = `Sensor - ${status.state}${reason}`;
    }

    return <i className={className} aria-hidden="true" data-tooltip-id="global-tooltip" data-tooltip-content={tooltip}></i>;
}

function StatusIcon(props: { instanceId?: number, removeFromList?: Function, hostId?: number, mode?: string }) {
    const { instanceId, removeFromList, hostId } = props;
    const instanceStatus = useInstanceStatus(instanceId || 0);
    const hostStatus = useHostStatus(hostId || 0);
    const status = (instanceId && instanceId > 0) ? instanceStatus : hostStatus;

    return <StatusIconDisplay instanceId={instanceId} removeFromList={removeFromList} hostId={hostId} status={status} />;
}

export { StatusIconDisplay };
export default memo(StatusIcon);
